<template>
  <el-row class="u-page">
    <el-pagination
      :small="small"
      prev-text="上一页"
      next-text="下一页"
      :pager-count="pageCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :layout="layout"
      :total="itemTotal"
    >
    </el-pagination>
  </el-row>
</template>
<script>
import { toRefs, watch, reactive } from 'vue';
import { ElPagination, ElRow } from 'element-plus';
export default {
  emits: ['change'],
  name: 'TmPagination',
  components: {
    ElPagination,
    ElRow,
  },
  props: {
    pageCount: {
      type: Number,
      default: 7,
    },
    // 分页
    size: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 50, 100];
      },
    },
    // 当前页
    current: {
      type: Number,
      default: 1,
    },
    // 总数
    total: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    let { current, total, size } = toRefs(props);
    const state = reactive({
      pageIndex: current,
      itemTotal: total,
      pageSize: size,
    });
    // 监听
    watch(
      () => [current, total],
      ([index, num]) => {
        state.pageIndex = index;
        state.itemTotal = num;
      }
    );
    /**
     * @description: 分页size切换
     * @param {*} size
     * @return {*}
     */
    const handleSizeChange = (size) => {
      const { pageIndex } = state;
      emit('change', { pageIndex, pageSize: size, type: 'current' });
    };
    /**
     * @description: 分页current切换
     * @param {*} index
     * @return {*}
     */
    const handleCurrentChange = (index) => {
      const { pageSize } = state;
      emit('change', { pageIndex: index, pageSize, type: 'size' });
    };
    return { ...toRefs(state), handleSizeChange, handleCurrentChange };
  },
};
</script>
